<template>
  <VideoSDKSuccess v-if='$context.is.buyNow || $context.is.basic2pro' />
  <success v-else :show-promotes='false'>
    <thanks :email='email' :title="title">
      <view-account />
    </thanks>
  </success>
</template>
<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import common from '@/views/succezz/mixin/common';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import VideoSDKSuccess from '@/plans/VIDEO_SDK/success.vue';

export default {
  name: "LDKCMR",
  mixins: [common],
  components: { ViewAccount, Success, Thanks, VideoSDKSuccess },
}
</script>
